<template>
	<div class="content">
		<!-- <Header></Header> -->
		<router-view></router-view>
		<Footer></Footer>
	</div>
</template>

<script>
	// import Header from './header.vue'
	import Footer from './footer.vue'
	export default({
		components:{
			// Header,
			Footer
		}
	})
</script>

<style lang="scss" scoped>
	.content{
		background:#fff;
	}
</style>